export default __webpack_public_path__ + "static/media/trustero.25bfcbc3.svg";